<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platid" filterable placeholder="筛选所属分组" @on-change="updatePlat">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_id" filterable placeholder="筛选代理" :max-tag-count="3" @on-change="getAppGenList">
                            <Option v-for="(item, index) in getAppList()" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">商户:</span>
                        <Select v-model="table.params.general_id" filterable placeholder="筛选 商户" :max-tag-count="3" @on-change="updateGeneral">
                            <Option v-for="(item, index) in select.general_list" :value="item.general" :label="item.general_name" :key="index">
                                {{ item.general_name }}
                                <span style="color: #bbb">({{ item.general }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="6">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">子商户 :</span>
                        <Select
                            v-model="table.params.pack_no"
                            filterable
                            placeholder="筛选 子商户
"
                            clearable
                        >
                            <Option v-for="(item, index) in getPackList()" :value="item.pack_no" :label="item.pack_name" :key="index">
                                {{ item.pack_name }}
                                <span style="color: #bbb">({{ item.pack_no }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">统计时间:</span>
                        <DatePicker type="daterange" v-model="table.params.dataTime" placeholder="统计时间" :options="dateOptions" style="width: 100%"></DatePicker>
                    </label>
                </Col>
                <Col span="6" style="display: flex; justify-content: space-between">
                    <Button type="primary" @click.native="searchData()">查询</Button>
                    <div>
                        <Button type="primary" @click.native="eleToExcel()" style="margin-right: 12px">导出excle</Button>
                        <Button type="primary" @click.native="eleToPdf()">导出pdf</Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'SummaryOfWinnings',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            select: {
                general_list: [],
                pack_list: []
            },
            all: {},
            //活动数据
            // GetZhuanPanActiveData
            table: {
                app_name: '',
                gp_name: '',
                params: {
                    general_id: -1,
                    platid: 0,
                    app_id: 0,
                    pack_no: -1,
                    dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
                },
                data: [],
                columns: [
                    {
                        key: 'time',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '日期', '显示对应的日期')
                    },
                    {
                        key: 'app_name',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称')
                    },
                    {
                        key: 'gp_name',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '子商户名称', '显示商户或者子商户名称')
                    },
                    {
                        key: 'new_user_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增注册人数', '筛选时间内,新增注册人数')
                    },
                    {
                        key: 'first_pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增首充人数', '筛选时间内,子商户新增首充人数')
                    },
                    {
                        key: 'pay_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当日转入金额', '筛选时间内,子商户转入金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_sum / 10000))
                    },
                    {
                        key: 'put_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转出金额', '筛选时间内,子商户转出金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.put_sum / 10000))
                    },
                    {
                        key: 'pay_put_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '充提差', '筛选时间内,子商户充提差'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.pay_put_sum / 10000))
                    },
                    {
                        key: 'new_win_sum',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '营收金额', '筛选时间内,子商户营收金额'),
                        render: (h, params) => h('span', this.getCustomFixed(params.row.new_win_sum / 10000))
                    },
                    {
                        key: 'new_win_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '营收比', '筛选时间内,商户或子商户的（营收金额/转入金额'),
                        render: (h, params) => h('span', params.row.new_win_rate === -1 ? '-' : (params.row.new_win_rate * 100).toFixed(2) + '%')
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData() {
            let stime = this.getSecond(this.table.params.dataTime[0])
            let etime = this.getSecond(this.table.params.dataTime[1], false)
            if ((etime - stime) / (60 * 60 * 24) > 15) {
                return this.$Message.error('只能搜索15天数据')
            }
            let forStime = new Date(this.table.params.dataTime[0]).getTime() / 1000
            let forEtime = new Date(this.table.params.dataTime[1]).getTime() / 1000
            let dayList = []
            for (let i = forEtime; i >= forStime; ) {
                dayList.push(moment(i * 1000).format('YYYY-MM-DD'))
                i -= 24 * 60 * 60
            }
            let pack_no = this.table.params.pack_no === undefined ? -1 : this.table.params.pack_no
            let app_name = this.app_list.find((el) => el.appid == this.table.params.app_id)['appName']
            let gp_name = pack_no == -1 ? this.select.general_list.find((el) => el.general == this.table.params.general_id)['general_name'] : this.select.pack_list.find((el) => el.pack_no == pack_no)['pack_name']
            let { platid, app_id, general_id } = this.table.params
            let params = this.getTransTopParams('GetNewPlatfromData', { app_id, platid, stime, etime, page: 1, limit: 10000, sort: 0, general: general_id, pack_no })
            this.table.data = []
            TransTopReq(params).then((res) => {
                let data = res._param.data || []
                this.all = res._param
                delete this.all.data
                this.all.time = '合计'
                let first_pay_num = 0
                data.forEach((item, index) => {
                    item.app_name = app_name
                    item.gp_name = gp_name
                    first_pay_num += item.first_pay_num
                    if (!item.time) {
                        item.time = dayList[index]
                    } else {
                        item.time = moment(item.time).format('YYYY-MM-DD')
                    }
                })
                this.all.first_pay_num = first_pay_num
                data = [...data, this.all]
                this.table.data = data
            })
        },

        async toHttp(httpList, pack_map) {
            if (httpList.length > 0) {
                let params = httpList.shift()
                let app_name = this.app_list.find((el) => el.appid == params.app_id)['appName']
                TransTopReq(params).then((res) => {
                    let data = res._param.list || []
                    data.forEach((item) => {
                        item.app_name = app_name
                        item.pack_name = pack_map[item.pack_no]
                        item.loss_pay_rate = this.calcRate(item.loss_point, item.pay_sum)
                        item.pay_put_sum = item.pay_sum - item.put_sum
                    })
                    this.table.data = data
                })
            }
        },

        getAppList() {
            return this.app_list.filter((el) => this.table.params.platid == el.platform)
        },
        getAppGenList() {
            let params = this.getTransTopParams('GetAppGeneralList', {
                app_id: this.table.params.app_id,
                platid: this.table.params.platid,
                stime: this.getSecond(this.table.params.dataTime[0]),
                etime: this.getSecond(this.table.params.dataTime[1], false),
                page: 1,
                limit: 10000,
                sort: 0,
                general: -1,
                pack_no: -1
            })
            this.select.general_list = []
            this.select.pack_list = []
            this.table.params.general_id = -1
            this.table.params.pack_no = -1
            TransTopReq(params).then((res) => {
                this.select.general_list = res._param.general_list
                this.table.params.general_id = this.select.general_list[0]['general']
                let params1 = this.copyData(params)
                params1.param._func = 'GetPackList'
                TransTopReq(params1).then((res1) => {
                    this.select.pack_list = res1._param.pack_list || []
                    this.searchData()
                })
            })
        },
        updateGeneral() {
            this.table.params.pack_no = -1
        },
        getPackList() {
            return this.select.pack_list.filter((el) => el.general == this.table.params.general_id)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        pageChange() {},
        limitChange() {},
        updatePlat() {
            this.table.params.app_id = this.getAppList()[0]['appid']
            this.getAppGenList()
        },
        initFunc() {
            this.table.params.platid = this.getinitPlatId()
            this.table.params.app_id = this.app_list.find((el) => el.platform == this.table.params.platid)['appid']
            this.getAppGenList()
        }
    },

    created() {
        this.initFunc()
    }
}
</script>

<style scoped lang="less"></style>
